import { createRouter, createWebHistory } from "vue-router";
import { useNavbarStore } from "../store/v2/navbar";
import { useClientStore } from "../store/v2/client";
import { useUserStore } from "../store/v2/user";
import routes from "../routes";

export default {
  install: (app, options) => {
    const router = createRouter({
      history: createWebHistory(),
      routes,
    });

    const routeAuthorize =
      import.meta.env.VITE_BACKEND_HOST + "/api/v1/oauth/authorize";
    const redirectUri = import.meta.env.VITE_BASE_URL + "/oauth2_callback";
    const clientId = import.meta.env.VITE_OAUTH2_CLIENT_ID;

    router.afterEach(async (to, from) => {
      window.scrollTo(0, 0);
    });

    router.beforeEach(async (to, from) => {
      const clientStore = useClientStore();
      const userStore = useUserStore();
      const navbarStore = useNavbarStore();
      navbarStore.resetActiveNavigationCategory();

      // oauth2 callback from server
      if (to.path === "/oauth2_callback") {
        const codeVerifier =
          await app.config.globalProperties.$userAuthenticator.getAuthorizationCodeVerifier();

        await app.config.globalProperties.$userAuthenticator.authorize(
          to.query.code ?? "NO_CODE",
          codeVerifier,
          redirectUri,
          clientId
        );

        await userStore.getUser();
        await clientStore.getClient(userStore.getClientCode, null, true);

        return {
          name: "feed",
          params: {
            slug: clientStore.slug,
          },
        };
      }

      // check if the user is authorized (make sure this happens *after* the callback is executed)
      const userIsAuthorized =
        app.config.globalProperties.$userAuthenticator.isAuthorized();

      if (clientStore.isMaintenance === true && userIsAuthorized) {
        await userStore.getUser();
      }

      // redirect to maintenance page if client has maintenance mode set
      if (
        to.name !== "maintenancePage" &&
        typeof clientStore.isMaintenance !== "undefined" &&
        clientStore.isMaintenance === true &&
        userStore.getCanBypassMaintenance !== true
      ) {
        return {
          name: "maintenancePage",
        };
      }

      if (!userIsAuthorized && !to.meta.isPublic) {
        // Redirect user to login if not authorized
        await redirectToAuthentication({
          clientCode:
            to.params.slug && to.params.slug !== "feed" ? to.params.slug : null,
        });
        /*app.config.globalProperties.$userAuthenticator.logout();
        if (to.params.slug !== null && to.params.slug !== undefined) {
          return {
            name: "slugLogin",
            params: {
              slug: to.params.slug,
            },
          };
        }

        return {
          name: "login",
        };*/
      }

      return true;
    });

    const redirectToAuthentication = async (queryParams) => {
      const codeVerifier =
        await app.config.globalProperties.$userAuthenticator.getAuthorizationCodeVerifier();
      const codeChallenge =
        await app.config.globalProperties.$userAuthenticator.getAuthorizationCodeChallenge(
          codeVerifier
        );

      let targetUrl =
        routeAuthorize +
        `?client_id=${clientId}` +
        `&redirect_uri=${redirectUri}` +
        `&response_type=code` +
        `&code_challenge_method=S256` +
        `&code_challenge=${codeChallenge}`;

      if (queryParams) {
        targetUrl +=
          "&" +
          new URLSearchParams(
            Object.fromEntries(
              Object.entries(queryParams).filter(
                ([key, value]) => value !== undefined && value !== null
              )
            )
          ).toString();
      }

      // see the same line above in oauth2_callback
      document.body.setAttribute("style", "display: none;");
      window.location.href = targetUrl;
    };

    const getRouter = () => {
      return router;
    };

    app.provide("redirectToAuthentication", redirectToAuthentication);

    app.config.globalProperties.$routerPlugin = {
      getRouter,
      redirectToAuthentication,
    };
  },
};
